// extracted by mini-css-extract-plugin
export var after = "case-studies-module--after--195f0";
export var before = "case-studies-module--before--3592f";
export var beforeAfter = "case-studies-module--beforeAfter--d3829";
export var caseStudiesContainer = "case-studies-module--caseStudiesContainer--4c0d9";
export var caseStudyImage = "case-studies-module--caseStudyImage--a9024";
export var caseStudyItem = "case-studies-module--caseStudyItem--b4e53";
export var checkmark = "case-studies-module--checkmark--4e9a1";
export var companyInfo = "case-studies-module--companyInfo--b2b90";
export var companyLogoSmall = "case-studies-module--companyLogoSmall--a8a06";
export var contentContainer = "case-studies-module--contentContainer--7be40";
export var imageContainer = "case-studies-module--imageContainer--9e7ce";
export var mediaAndDetailsContainer = "case-studies-module--mediaAndDetailsContainer--ecc68";
export var mediaElement = "case-studies-module--mediaElement--9f243";
export var mediaPlaceholder = "case-studies-module--mediaPlaceholder--9c9d5";
export var originalQuote = "case-studies-module--originalQuote--2744b";
export var pointItem = "case-studies-module--pointItem--38797";
export var pointsList = "case-studies-module--pointsList--dca10";
export var resultsSection = "case-studies-module--resultsSection--6f0f7";
export var savings = "case-studies-module--savings--4c229";
export var situationSection = "case-studies-module--situationSection--0db13";
export var textualContentContainer = "case-studies-module--textualContentContainer--c9025";
export var videoPlaceholder = "case-studies-module--videoPlaceholder--5dc10";